// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-with-weight-target-container[data-v-56beebe0] {\n  text-align: center;\n  margin-top: 1.5rem;\n}\n.title-with-weight-target-container__title[data-v-56beebe0] {\n  font-weight: 900;\n  font-size: 2.1rem;\n  line-height: 1.2;\n}\n.title-with-weight-target-container__target[data-v-56beebe0] {\n  display: block;\n  margin-top: 12px;\n  font-weight: 500;\n  font-size: 1.5rem;\n  line-height: 21px;\n  color: #323653;\n}", ""]);
// Exports
module.exports = exports;
